import http from "./http";

/**
 * Fetch the current login page image details.
 * GET admin/manage_images.php
 */
export const getLoginImage = async () => {
  try {
    const res = await http.get("admin/manage_images.php");
    return res.data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || error.message || "Failed to fetch image",
    };
  }
};

/**
 * Upload or update the login page image.
 * POST admin/manage_images.php
 */
export const uploadLoginImage = async (imageFile) => {
  try {
    const formData = new FormData();
    formData.append("image", imageFile);

    const res = await http.post("admin/manage_images.php", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || error.message || "Failed to upload image",
    };
  }
};

/**
 * Delete/remove the login page image.
 * DELETE admin/manage_images.php
 */
export const deleteLoginImage = async (imageFile = null) => {
  try {
    const config = {};
    if (imageFile) {
      const formData = new FormData();
      formData.append("image", imageFile);
      config.data = formData;
      config.headers = {
        "Content-Type": "multipart/form-data",
      };
    }
    const res = await http.delete("admin/manage_images.php", config);
    return res.data;
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || error.message || "Failed to delete image",
    };
  }
};
